import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { getSuperAdminAuthToken } from '../../shared/utils/auth-headers.util';
import { AggregatedStatusResponse } from '../models/status.model';

@Injectable({ providedIn: 'root' })
export class StatusService {
  private readonly url = `${environment.baseUrl}/${environment.apiVersion}/status`;

  constructor(private readonly http: HttpClient) {}

  getAggregatedStatus(): Observable<AggregatedStatusResponse> {
    let headers = new HttpHeaders({ Accept: 'application/json' });
    const token = getSuperAdminAuthToken();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    } else if (environment.superAdminApiKey) {
      headers = headers.set('api-key', environment.superAdminApiKey);
    }
    return this.http.get<AggregatedStatusResponse>(this.url, { headers });
  }
}
